import httpClient from './httpClient';

class ActivityLogsService {
  // Get all activity logs (OTP)
  async getActivityLogs() {
    try {
      const response = await httpClient.get('/api/admin/activity-logs');
      return response;
    } catch (error) {
      console.error('Error fetching activity logs:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء جلب سجلات النشاط'
      };
    }
  }
}

export default new ActivityLogsService();

